import * as Types from '../Constants/AllConstants';


export const GetAllAuditsReducer = (state = { audits: [] }, action) => {
  switch (action.type) {
    case Types.AUDIT_LIST_REQUEST:
      return { loading: true };
    case Types.AUDIT_LIST_SUCCESS:
      return {
        loading: false,
        audits: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.AUDIT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetUserAuditsByPeriodReducer = (state = { audits: [] }, action) => {
  switch (action.type) {
    case Types.USER_AUDIT_PERIOD_REQUEST:
      return { loading: true };
    case Types.USER_AUDIT_PERIOD_SUCCESS:
      return {
        loading: false,
        audits: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.USER_AUDIT_PERIOD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetMyAuditsByPeriodReducer = (state = { audits: [] }, action) => {
  switch (action.type) {
    case Types.MY_AUDIT_PERIOD_REQUEST:
      return { loading: true };
    case Types.MY_AUDIT_PERIOD_SUCCESS:
      return {
        loading: false,
        audits: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.MY_AUDIT_PERIOD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


export const AuditDetailsReducer = (state = { audit: {} }, action) => {
  switch (action.type) {
    case Types.AUDIT_DETAILS_REQUEST:
      return { loading: true };
    case Types.AUDIT_DETAILS_SUCCESS:
      return { loading: false, audit: action.payload };
    case Types.AUDIT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
